export const MainBalconyRenewal = {
    "imageUrl": "/assets/imgs/services/9BalconyRenewal/fondo.png",
    "eyebrow": "Balcony",
    "title": "Renewal",
    "headingSpan": "RESTORE, PROTECT AND ENHANCE",
    "heading": "YOUR OUTDOOR SPACES",
    "description": "Balconies are constantly exposed to weather, moisture, and daily wear, leading to cracking, spalling, rusted railings, and waterproofing failures. At HRD Painting & Restoration, we specialize in comprehensive balcony renewal services, ensuring structural integrity, safety, and long-lasting durability for commercial, high-rise, and multi-unit residential buildings.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};